import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e15a92b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "moldura-imagem" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "conteudo-servico" }
const _hoisted_5 = { class: "numero-servico" }
const _hoisted_6 = { class: "paragrafo-titulo" }
const _hoisted_7 = { class: "paragrafo-texto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    class: "container-servico",
    href: _ctx.linkWhatsApp(_ctx.TextoWhatsApp),
    target: "_blank",
    rel: "noopener",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.registrarClique('Serviços')))
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: require(`../assets/${_ctx.Imagem}`),
        alt: `Ilustração: ${_ctx.Titulo}`,
        class: "imagem-servico",
        loading: "lazy"
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.Numero), 1),
      _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.Titulo), 1),
      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.Texto), 1)
    ])
  ], 8, _hoisted_1))
}